/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react';
import { Pagination, Tag, Checkbox, Divider, Button } from 'antd';
import {
    DeleteOutlined,
    DownloadOutlined,
    LoadingOutlined,
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { STATUS_ID } from '../../STATUS_ID';
import useNotify from '../../../../context/Notification/useNotify';
import IconEmpty from '../../../../assets/Images/icons/empty';
import IconExpand from '../../../../assets/Images/icons/icon-expand';
import RiskAssessmentService from '../../../../services/RiskAssessment.service';
import moment from 'moment';
import ModalCreateRiskRegister from './ModalCreateRiskRegister';
import UserService from '../../../../services/UserService';
import ModalDelete from '../../../../components/Shared/modal/delete';
import RiskRegisterService from '../../../../services/RiskRegister.service';
import { ROUTER } from '../../../../constants/router';
import usePermission from '../../../../hooks/usePermission';

export default function ListCardTab2({
    search,
    headerData,
    currentPage,
    setCurrentPage,
    dataSource,
    total,
    setLoading,
    checkedAll,
    setCheckedAll,
    isCheckedAll,
    setIsCheckedAll,
    select,
    setSelect,
    setDataSelection,
    dataSelection,
    setAllSelection,
    allSelection,
    allDataSelection,
    setAllDataSelection,
    riskAssessmentId,
}) {
    const { t } = useTranslation();
    const notify = useNotify();
    const navigate = useNavigate();
    const [openDelete, setOpenDelete] = useState(false);
    const role = UserService.role().toLowerCase();
    const admin = ['admin', 'auditor', 'super admin'].includes(role);
    const { isAuditor } = usePermission();

    const [editMode, setEditMode] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [loading_, setLoading_] = useState(false);

    useEffect(() => {
        if (dataSource) {
            if (admin) {
                setEditMode('view');
            } else {
                //Waiting for Review and Reviewed
                if (
                    dataSource.statusId === STATUS_ID.WAITING_FOR_REVIEW ||
                    dataSource.statusId === STATUS_ID.REVIEWED
                ) {
                    setEditMode('view');
                } else {
                    setEditMode('edit');
                }
            }
        }
    }, [admin, dataSource]);

    const deleteRiskRegister = () => {
        setOpenDelete(false);
        try {
            const { data } = RiskRegisterService.deleteRiskRegister({
                riskRegisterIds: select.join(','),
            });
            if (data?.resultCode === 0) {
                notify({
                    type: 'error',
                    title: t('common.Fail'),
                    description: t('common.FailedDeleteData'),
                    timeOut: 120000,
                    closeable: true,
                });
            } else {
                notify({
                    title: t('common.Success'),
                    description: t('Successfully deleted data'),
                    timeOut: 2000,
                });
                setTimeout(() => {
                    search();
                }, 2300);
            }
        } catch (error) {
            console.log(error);
            notify({
                type: 'error',
                title: t('common.Fail'),
                description: t('common.FailedDeleteData'),
                timeOut: 120000,
                closeable: true,
            });
        }
    };
    const exportRiskRegisterList = (e) => {
        setLoading_(true);
        setTimeout(async () => {
            try {
                const res = await RiskAssessmentService.exportRiskRegisterList({
                    riskRegisterIds: select.join(','),
                });
                const filename =
                    res.headers['content-disposition'].split('filename=')[1];
                const objectURL = window.URL.createObjectURL(
                    new Blob([res?.data])
                );
                const link = document.createElement('a');
                link.href = objectURL;
                link.download = filename;
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
                setLoading_(false);
            } catch (error) {
                console.log(error);
                setLoading_(false);
                notify({
                    type: 'error',
                    title: t('common.Fail'),
                    description: 'Failed to downloaded.',
                });
            }
        }, 1200);
    };

    useEffect(() => {
        let selectAll = dataSource?.map((data) => data.riskRegisterId);
        let count = 0;
        select?.map((res, i) => {
            if (selectAll.includes(res)) {
                count += 1;
            }
        });
        if (count === dataSource?.length && selectAll.length !== 0) {
            setCheckedAll(true);
        } else {
            setCheckedAll(false);
        }
    }, [currentPage.page, select, dataSource]);

    useEffect(() => {
        let selectAll = dataSource?.map((data) => data.riskRegisterId);
        // Select Per Page
        const selectPerPage = [];
        const dataSelectionPerPage = [];
        allSelection?.map((res) => {
            if (selectAll.includes(res)) {
                selectPerPage.push(res);
            }
        });
        allDataSelection?.map((res) => {
            if (selectAll.includes(res?.riskRegisterId)) {
                dataSelectionPerPage.push(res);
            }
        });
        setSelect(selectPerPage);
        setDataSelection(dataSelectionPerPage);
    }, [dataSource]);

    const validateDelete = () => {
        const deletableStatuses = ['Draft', 'Revise'];
        const nonDeletableStatuses = ['Waiting for Review', 'Reviewed'];

        const hasDeletable = dataSelection.some((result) =>
            deletableStatuses.includes(result.statusEn)
        );
        const hasNonDeletable = dataSelection.some((result) =>
            nonDeletableStatuses.includes(result.statusEn)
        );

        return hasDeletable && !hasNonDeletable;
    };

    return (
        <>
            <div className="grid gap-3">
                {' '}
                <div className="p-4 pb-0">
                    <div
                        className={`flex items-center space-x-4 bg-white w-full py-3 px-3 rounded-lg ${
                            headerData || dataSource?.length > 0 ? '' : 'hidden'
                        }`}
                    >
                        <div className="flex items-center h-full">
                            <Checkbox
                                disabled={isAuditor}
                                checked={checkedAll}
                                onClick={(e) => {
                                    setCheckedAll(e.target.checked);
                                    let selectAll = dataSource?.map(
                                        (data) => data.riskRegisterId
                                    );

                                    let IsSelectAll = allSelection;

                                    let IsDataSelection = allDataSelection;
                                    // All Data Select
                                    selectAll?.map((res, i) => {
                                        if (!IsSelectAll.includes(res)) {
                                            IsSelectAll.push(res);
                                        }
                                    });
                                    dataSource?.map((res, i) => {
                                        if (!IsDataSelection.includes(res)) {
                                            IsDataSelection.push(res);
                                        }
                                    });
                                    // Select Per Page
                                    let allSelectPerPage = [];
                                    let allDataSelectionPerPage = [];
                                    IsSelectAll?.map((res, i) => {
                                        if (selectAll.includes(res)) {
                                            allSelectPerPage.push(res);
                                        }
                                    });
                                    IsDataSelection?.map((res, i) => {
                                        if (
                                            selectAll.includes(
                                                res?.riskRegisterId
                                            )
                                        ) {
                                            allDataSelectionPerPage.push(res);
                                        }
                                    });

                                    if (e.target.checked) {
                                        setSelect(allSelectPerPage);
                                        setAllSelection(IsSelectAll);
                                        setAllDataSelection(
                                            allDataSelectionPerPage
                                        );
                                        setDataSelection(IsDataSelection);
                                    } else {
                                        setIsCheckedAll(false);
                                        let itemSelect = allSelection;
                                        let itemDataSelecttion =
                                            allDataSelection;
                                        // All Data Select
                                        selectAll?.map((res, i) => {
                                            let set = itemSelect.filter(
                                                (data) => data !== res
                                            );
                                            itemSelect = set;
                                        });
                                        dataSource?.map((res, i) => {
                                            let set = itemDataSelecttion.filter(
                                                (data) =>
                                                    data?.riskRegisterId !==
                                                    res?.riskRegisterId
                                            );
                                            itemDataSelecttion = set;
                                        });

                                        // Select Per Page
                                        const selectPerPage = [];
                                        const dataSelectionPerPage = [];
                                        itemSelect?.map((res) => {
                                            if (selectAll.includes(res)) {
                                                selectPerPage.push(res);
                                            }
                                        });
                                        itemDataSelecttion?.map((res) => {
                                            if (
                                                selectAll.includes(
                                                    res?.riskRegisterId
                                                )
                                            ) {
                                                dataSelectionPerPage.push(res);
                                            }
                                        });
                                        setSelect(selectPerPage);
                                        setAllSelection(itemSelect);
                                        setDataSelection(dataSelectionPerPage);
                                        setAllDataSelection(itemDataSelecttion);
                                    }
                                }}
                            />
                        </div>
                        <div className="font-semibold text-sm flex w-full justify-between items-center">
                            <div className="flex space-x-2 items-center">
                                <div>
                                    <span>
                                        {t('RList.SelectAll')} ({select?.length}
                                        )
                                    </span>
                                </div>
                                <div className="flex items-center space-x-2">
                                    {validateDelete() ? (
                                        <button
                                            onClick={(e) => setOpenDelete(true)}
                                            className="bg-[#F3F6F9] h-8 w-8 flex items-center justify-center rounded-lg text-error text-sm"
                                        >
                                            <DeleteOutlined />
                                        </button>
                                    ) : (
                                        <span
                                            className="cursor-not-allowed bg-[#F3F6F9] h-8 w-8 flex items-center justify-center rounded-lg"
                                            style={{
                                                padding: '4px 7px',
                                                color: '#7B67FB',
                                            }}
                                        >
                                            <DeleteOutlined
                                                className="text-[#ADADAD]"
                                                disabled
                                            />
                                        </span>
                                    )}
                                    {select.length > 0 ? (
                                        <button
                                            onClick={() => {
                                                exportRiskRegisterList();
                                            }}
                                            className="bg-[#F3F6F9] h-8 w-8 flex items-center justify-center rounded-lg text-purple text-sm"
                                        >
                                            {loading_ ? (
                                                <LoadingOutlined />
                                            ) : (
                                                <DownloadOutlined />
                                            )}
                                        </button>
                                    ) : (
                                        <span
                                            className="cursor-not-allowed bg-[#F3F6F9] h-8 w-8 flex items-center justify-center rounded-lg"
                                            style={{
                                                padding: '4px 7px',
                                                color: '#7B67FB',
                                            }}
                                        >
                                            <DownloadOutlined
                                                className="text-[#ADADAD]"
                                                disabled
                                            />
                                        </span>
                                    )}
                                </div>
                            </div>
                            <div>
                                <Button
                                    disabled={admin}
                                    hidden={!headerData}
                                    size="large"
                                    type="primary"
                                    onClick={async () => {
                                        if (dataSource?.length > 0) {
                                            setShowModal(true);
                                        } else {
                                            try {
                                                const { data } =
                                                    await RiskRegisterService.createRiskRegisterInitial(
                                                        {
                                                            riskAssessmentId:
                                                                riskAssessmentId,
                                                        }
                                                    );
                                                if (data.resultCode === 1) {
                                                    navigate(
                                                        `${ROUTER.RISK_MANAGEMENT.RR}/${data?.resultData?.riskRegisterId}`,
                                                        {
                                                            state: {
                                                                mode: 'create',
                                                            },
                                                        }
                                                    );
                                                    setLoading(false);
                                                } else {
                                                    setLoading(false);
                                                    notify({
                                                        type: 'error',
                                                        title: t('common.Fail'),
                                                        description:
                                                            data?.errorData
                                                                ?.msg,
                                                    });
                                                }
                                            } catch (error) {
                                                setLoading(false);
                                                notify({
                                                    type: 'error',
                                                    title: t('common.Fail'),
                                                    description: error,
                                                });
                                            }
                                        }
                                    }}
                                >
                                    {t('RR.CreateRR')}
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="overflow-auto max-h-[58vh] grid gap-3 px-4">
                    {dataSource?.length > 0 ? (
                        dataSource?.map((item) => (
                            <Card
                                key={item.riskRegisterId}
                                setDataSelection={setDataSelection}
                                setSelect={setSelect}
                                item={item}
                                select={select}
                                dataSelection={dataSelection}
                                checkedAll={checkedAll}
                                setCheckedAll={setCheckedAll}
                                currentPage={currentPage}
                                total={total}
                                isCheckedAll={isCheckedAll}
                                setIsCheckedAll={setIsCheckedAll}
                                allDataSelection={allDataSelection}
                                setAllDataSelection={setAllDataSelection}
                                setAllSelection={setAllSelection}
                                allSelection={allSelection}
                                dataSource={dataSource}
                                setCurrentPage={setCurrentPage}
                                editMode={editMode}
                            />
                        ))
                    ) : (
                        <div className="h-[35vh] grid items-center justify-center">
                            <div className="-mt-16">
                                <IconEmpty />
                            </div>
                        </div>
                    )}
                </div>
            </div>
            <div className="w-full text-right mt-4">
                <Pagination
                    current={currentPage?.page || 1}
                    pageSizeOptions={[10, 20, 30]}
                    defaultPageSize={10}
                    total={currentPage?.total || 1}
                    onChange={(page, pageSize) => {
                        const pageValue = {
                            ...currentPage,
                            page: page,
                            pageSize: pageSize,
                        };
                        setLoading(true);
                        setCurrentPage(pageValue);
                        setIsCheckedAll(false);
                        setSelect([]);
                        setDataSelection([]);
                        setCheckedAll(false);
                    }}
                    showSizeChanger
                />
            </div>
            <ModalCreateRiskRegister
                riskAssessmentId={riskAssessmentId}
                open={showModal}
                handelClose={() => setShowModal(false)}
            />
            <ModalDelete
                // loading={loading}
                open={openDelete}
                text={`Do you want to delete ?`}
                handelOk={() => deleteRiskRegister()}
                handelClose={() => setOpenDelete(false)}
            />
        </>
    );
}

const Card = ({
    setCheckedAll,
    setIsCheckedAll,
    item,
    select,
    setSelect,
    dataSelection,
    setDataSelection,
    currentPage,
    total,
    setAllSelection,
    allSelection,
    allDataSelection,
    setAllDataSelection,
    dataSource,
}) => {
    const { t, i18n } = useTranslation();
    const [expand, setExpand] = useState(false);
    const role = UserService.role().toLowerCase();
    const admin = ['admin', 'auditor', 'super admin'].includes(role);

    const { isAuditor } = usePermission();

    const Navigate = useNavigate();
    const _getTagStatus = (e) => {
        switch (e) {
            case 'Draft':
                return { color: '#65707A', borderColor: '#65707A' };
            case 'Waiting for Review':
                return { color: '#F9C153', borderColor: '#F9C153' };
            case 'Reviewed':
                return { color: '#4ACE8F', borderColor: '#4ACE8F' };
            case 'Revise':
                return { color: '#F0536F', borderColor: '#F0536F' };
            default:
                return { color: '#FFF', background: '' };
        }
    };
    return (
        <div className="flex bg-white w-full pt-4 px-3 rounded-lg space-x-3 border-hover transform duration-300 hover:scale-[1.01]">
            <div className="flex h-full mr-3">
                <Checkbox
                    disabled={isAuditor}
                    checked={select.find((s) => s === item?.riskRegisterId)}
                    onClick={(e) => {
                        if (e.target.checked) {
                            let selectAll = dataSource?.map(
                                (data) => data.riskRegisterId
                            );
                            let allSelectData = [
                                ...allSelection,
                                item?.riskRegisterId,
                            ];
                            let selectData = [];
                            allSelectData?.map((res) => {
                                if (selectAll?.includes(res)) {
                                    selectData.push(res);
                                }
                            });
                            let allSelectDataSelection = [
                                ...allDataSelection,
                                item,
                            ];
                            let dataSelectionData = [];
                            allSelectDataSelection?.map((res) => {
                                if (selectAll?.includes(res?.riskRegisterId)) {
                                    dataSelectionData.push(res);
                                }
                            });
                            setSelect(selectData);
                            setAllSelection(allSelectData);
                            setDataSelection(dataSelectionData);
                            setAllDataSelection(allSelectDataSelection);
                            if (
                                select?.length + 1 === currentPage.pageSize ||
                                select?.length + 1 === total
                            ) {
                                setCheckedAll(true);
                            }
                        } else {
                            setSelect(
                                select.filter(
                                    (data) => data !== item.riskRegisterId
                                )
                            );
                            setAllSelection(
                                allSelection.filter(
                                    (data) => data !== item.riskRegisterId
                                )
                            );
                            setDataSelection(
                                dataSelection.filter(
                                    (data) =>
                                        data?.riskRegisterId !==
                                        item?.riskRegisterId
                                )
                            );
                            setAllDataSelection(
                                allDataSelection.filter(
                                    (data) =>
                                        data?.riskRegisterId !==
                                        item?.riskRegisterId
                                )
                            );
                            setCheckedAll(false);
                            setIsCheckedAll(false);
                        }
                    }}
                />
            </div>

            <div className="w-full">
                <button
                    onClick={() => {
                        console.log(
                            item.statusId,
                            STATUS_ID.WAITING_FOR_REVIEW
                        );
                        Navigate(
                            `${ROUTER.RISK_MANAGEMENT.RR}/${item?.riskRegisterId}`,
                            {
                                state: {
                                    mode: admin
                                        ? 'view'
                                        : item.status ===
                                              STATUS_ID.WAITING_FOR_REVIEW ||
                                          item.status === STATUS_ID.REVIEWED
                                        ? 'view'
                                        : 'edit',
                                },
                            }
                        );
                    }}
                >
                    <div className="flex items-center font-medium text-base space-x-3 text-purple">
                        <div>{t('RList.RiskRegisterCode')} :</div>
                        <div className="text-tiny">
                            {item?.riskRegisterNumber || '-'}
                        </div>
                    </div>
                </button>
                <div className="grid grid-cols-2 mt-2">
                    <div className="space-y-2">
                        <div className="grid grid-cols-2 text-xs">
                            <strong className="text-xs">
                                {t('RList.Department')} :
                            </strong>
                            <div>
                                {i18n.language === 'en'
                                    ? item?.departmentEn || '-'
                                    : item?.departmentTh || '-'}
                            </div>
                        </div>
                        <div className="grid grid-cols-2 text-xs">
                            <strong className="text-xs">
                                {t('RList.Version')} :
                            </strong>
                            <div>{item?.version || '-'}</div>
                        </div>
                    </div>
                    <div className="space-y-2">
                        <div className="grid grid-cols-2 text-xs">
                            <strong className="text-xs">
                                {t('RList.Status')} :
                            </strong>
                            <div>
                                {item?.statusEn ? (
                                    <Tag
                                        className="rounded-xl -my-1 text-center"
                                        style={_getTagStatus(item?.statusEn)}
                                    >
                                        {i18n?.language === 'en'
                                            ? item?.statusEn || '-'
                                            : item?.statusTh || '-'}
                                    </Tag>
                                ) : (
                                    <>-</>
                                )}
                            </div>
                        </div>
                        <div className="grid grid-cols-2 text-xs">
                            <strong className="text-xs">
                                {t('RList.LastUpdate')} :
                            </strong>
                            <div>
                                {moment(item?.modifyDate).format(
                                    'DD/MM/YYYY HH:mm'
                                ) || '-'}
                            </div>
                        </div>
                    </div>
                </div>
                <Divider className="mb-2" />
                <div className="flex items-center py-1 space-x-4">
                    <div className="font-semibold text-base">
                        {t('RList.ActivityName')}
                    </div>
                    <div className="break-all text-xs text-gray-500">
                        ({item?.activityList?.length || 0} {t('Acitivity')})
                    </div>
                </div>
                {expand && (
                    <ul className="list-decimal">
                        {item?.activityList?.map((res) => (
                            <li className="list-decimal">{res.activityName}</li>
                        ))}
                    </ul>
                )}
                <div className="hover:animate-bounce duration-1000">
                    <button
                        onClick={() => {
                            setExpand(!expand);
                        }}
                        className={`cursor-pointer w-full text-center transition py-2  
                        ${expand && 'rotate-180'}`}
                    >
                        <IconExpand />
                    </button>
                </div>
            </div>
        </div>
    );
};
